import angular from "angular";
import { SubFilter } from "./subFilters";

export class BetweenFilter extends SubFilter {
  private readonly type: string;

  constructor(config: { displayName: string; queryFieldNames: string[] | string[]; type?: string }) {
    super(config)

    this.type = config.type || 'text'
  }

  getGui(): angular.IAugmentedJQuery {
    return angular.element(`
    <div>
    <input type="${this.type}" ng-model="${this.getQueryFieldExpression()}" ng-model-options="gridFilterController.defaultModelOptions" class="form-control" />
    </div>
    and
    <div>
    <input ng-model="${this.getQueryFieldExpression(1)}" ng-model-options="gridFilterController.defaultModelOptions" class="form-control" />
    </div>
`)
  }
}